import axios from "axios";
import API from "./APIService";

class SystemSettingsService  {

	/**
	 * Creates a System setting url by concatenating Api url with given path and returns axios call
	 * @param path to get full api url
	 */
	fix = (path) => {
		if (path != null) {
			return axios.get(API.url(`system-settings/${path}`));
		}
		throw new Error("Path is not defined");
	}
	
}

export default SystemSettingsService;


// WEBPACK FOOTER //
// ./src/services/SystemSettingsService.js